import { render, staticRenderFns } from "./TypeEnvironmentItem.vue?vue&type=template&id=124861dd&"
import script from "./TypeEnvironmentItem.vue?vue&type=script&lang=js&"
export * from "./TypeEnvironmentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports